(function () {
  'use strict';

  const summaries = {
    normalglas: '2 mm Floatglas · ca. 45 % UV-Schutz · glänzend',
    antireflexglas: '2 mm Echtglas · ca. 45 % UV-Schutz · mattiert',
    kunstglas: '2 mm Acrylglas · 99 % UV-Schutz · bruchsicher',
    museumsglas: 'Weißglas · 70 % UV-Schutz · optisch entspiegelt',
    leerrahmen: 'Ohne Glas und Rückwand'
  };

  function resolveGlassKey(text) {
    const value = (text || '').toLowerCase();

    if (value.includes('museum')) return 'museumsglas';
    if (value.includes('kunst') || value.includes('acryl') || value.includes('plexi') || value.includes('ps')) {
      return 'kunstglas';
    }
    if (value.includes('antireflex') || value.includes('matt')) return 'antireflexglas';
    if (value.includes('leer') || value.includes('ohne')) return 'leerrahmen';

    return 'normalglas';
  }

  function getGlassOptionWrapper(element) {
    const wrapper = element && element.closest('.product-form__input');
    if (!wrapper) return null;

    const label = wrapper.querySelector('.form__label, legend');
    return label && /glas|glass/i.test(label.textContent) ? wrapper : null;
  }

  function getSelectedGlassKey() {
    const pickers = document.querySelectorAll('product-info variant-radios, product-info variant-selects, variant-radios, variant-selects');

    for (const picker of pickers) {
      const fields = picker.querySelectorAll('select, input[type="radio"]:checked');

      for (const field of fields) {
        if (getGlassOptionWrapper(field)) return resolveGlassKey(field.value);
      }
    }

    return null;
  }

  function activateComponent(component, glassKey, shouldScroll, moveFocus) {
    const activeTab = component.querySelector(`[data-glass-target="${glassKey}"]`);
    const activePanel = component.querySelector(`[data-glass-type="${glassKey}"]`);
    if (!activeTab || !activePanel) return;

    component.querySelectorAll('[data-glass-target]').forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('glass-info__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    component.querySelectorAll('[data-glass-type]').forEach((panel) => {
      const isActive = panel === activePanel;
      panel.hidden = !isActive;
      panel.classList.toggle('glass-info__panel--active', isActive);
    });

    if (shouldScroll) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      activeTab.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
    }
    if (moveFocus) activeTab.focus();
  }

  function updateSummaries(glassKey) {
    document.querySelectorAll('.glass-info-inline-summary').forEach((summary) => {
      summary.textContent = summaries[glassKey] || '';
    });
  }

  function syncWithProductSelection() {
    const glassKey = getSelectedGlassKey();
    if (!glassKey) return;

    document.querySelectorAll('[data-glass-info]').forEach((component) => {
      activateComponent(component, glassKey, false, false);
    });
    updateSummaries(glassKey);
  }

  function handleTabClick(event) {
    const tab = event.target.closest('[data-glass-target]');
    if (!tab) return;

    const component = tab.closest('[data-glass-info]');
    if (component) activateComponent(component, tab.dataset.glassTarget, true, false);
  }

  function handleTabKeydown(event) {
    const tab = event.target.closest('[data-glass-target]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const component = tab.closest('[data-glass-info]');
    const tabs = Array.from(component.querySelectorAll('[data-glass-target]'));
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    activateComponent(component, tabs[nextIndex].dataset.glassTarget, true, true);
  }

  function handleChange(event) {
    if (!getGlassOptionWrapper(event.target)) return;
    window.requestAnimationFrame(syncWithProductSelection);
  }

  function init() {
    syncWithProductSelection();
  }

  if (window.RahmenkontorGlassInfo) {
    window.RahmenkontorGlassInfo.init();
    return;
  }

  window.RahmenkontorGlassInfo = { init, syncWithProductSelection };
  document.addEventListener('click', handleTabClick);
  document.addEventListener('keydown', handleTabKeydown);
  document.addEventListener('change', handleChange);
  document.addEventListener('shopify:section:load', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.requestAnimationFrame(syncWithProductSelection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
